import { useMail } from "../../../../contexts/mailContext/mailContext.js";
import CoolGrid from "../CoolGrid/CoolGrid.js";

const GridList = () => {
  const { getFilesData, getFilesList } = useMail();

  return (
    <CoolGrid
      list={getFilesList()}
      obj={getFilesData()}
      containerClassName="grid-holder"
      isProUser={true} // isProUser setted to true due to hide banners from the grid, return to dynamic value when the banners are ready
    />
  );
};

export default GridList;
